export default __webpack_public_path__ + "static/sc1-750ebc30303f4d2cb7d93e60781a6a31.jpeg";